<template>
  <div :data-bs-theme="isDarktheme ? 'dark' : 'light'">
    <div class="container">
      <ErrorScreen v-if="serverState.isBackFault" :data="serverState" />
      <template v-else>
        <div class="text-center py-5">
          <div class="row align-items-start">
            <div class="col"></div>
            <div class="col"></div>
            <div class="col">
              <div class="form-check form-switch">
                <label class="form-check-label" for="switcher">Dark theme
                  <input class="form-check-input" type="checkbox" role="switch"
                    aria-checked="false"
                    id="switcher" v-model="isDarktheme" />
                </label>
              </div>
            </div>
          </div>
        </div>

        <Header :user="user" @fetchData="fetchData" />
        <Portfolio :data="portfolioList" :hidequote="user.info.Fake" />
        <Links :data="cv" :hidequote="user.info.Fake" />
        <Links :data="sml" :hidequote="user.info.Fake" />
        <Email :emailAddr="user.info.Email" />
        <Footer :buildInfo="buildInfo" />
      </template>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/api';
import {
  defineAsyncComponent, onMounted, reactive, ref,
} from 'vue';
import packageInfo from '../buildInfo.json';

const Header = defineAsyncComponent(() => import('../components/Header.vue'));
const Portfolio = defineAsyncComponent(() => import('../components/Portfolio.vue'));
const Links = defineAsyncComponent(() => import('../components/Links.vue'));
const Email = defineAsyncComponent(() => import('../components/Email.vue'));
const Footer = defineAsyncComponent(() => import('../components/Footer.vue'));
const ErrorScreen = defineAsyncComponent(() => import('../components/Error.vue'));

export default {
  name: 'HomePage',
  components: {
    Header,
    Portfolio,
    Links,
    Email,
    Footer,
    ErrorScreen,
  },
  setup() {
    const isDarktheme = ref(true);
    const id = ref(1);

    const serverState = reactive({
      isBackFault: false,
      showSpinner: false,
      header: 'Oops!',
      link: '/',
      linkText: 'Reload page',
      message: 'We have noticed a problem with our server. Our team is already working on it. Please be patient.',
    });

    const user = reactive({ info: {} });

    const portfolioList = reactive({
      portfolio: [],
      quote: {
        text: 'Fortunately, I Have Enough Talent For All Of You.',
        author: 'Squidward Tentacles',
      },
    });

    const cv = reactive({
      links: [],
      header: 'My CV.',
      quote: {
        text: 'I order the food, you cook the food. The customer gets the food. We do that for 40 years, and then we die.',
        author: 'Squidward Tentacles',
      },
    });

    const sml = reactive({
      links: [],
      header: 'My Social Media Links.',
      anchor: 'msml',
      quote: {
        text: 'Patrick, go be stupid somewhere else!',
        author: 'Squidward Tentacles',
      },
    });

    const buildInfo = reactive({
      front: {
        id: packageInfo.id,
        url: packageInfo.url,
        branch: packageInfo.branch,
      },
      back: {
        id: '',
        url: '',
        branch: '',
        count: '',
      },
    });

    const loadUserInfo = async (userId = 1) => {
      serverState.showSpinner = true;
      try {
        const res = await api.getUser(userId);
        user.info = res.data.Person;

        document.title = `${user.info.Name} ${user.info.Surname} - ${user.info.Jobtitle}`;

        portfolioList.portfolio = res.data.Projects || [];

        const links = res.data.Links || [];
        cv.links = links.filter((link) => link.Type === 'cv');
        sml.links = links.filter((link) => link.Type === 'socmedia');
      } catch (err) {
        console.error('Error loading user info:', err);
        serverState.isBackFault = true;
      } finally {
        serverState.showSpinner = false;
      }
    };

    const fetchBackInfo = async () => {
      try {
        const { data } = await api.backInfo();
        buildInfo.back.id = `${data.Hash} (${data.Branch})`;
        buildInfo.back.url = data.Build_url;
        buildInfo.back.count = data.Accounts;
      } catch (err) {
        console.error('Error fetching backend info:', err);
      }
    };

    const fetchData = async () => {
      try {
        const count = Number.parseInt(buildInfo.back.count, 10) || 1;
        const randomId = Math.floor(Math.random() * count) + 1;
        if (id.value === randomId) {
          await fetchData();
        } else {
          id.value = randomId;
          await loadUserInfo(randomId);
        }
      } catch (err) {
        console.error('Error fetching random user:', err);
        serverState.isBackFault = true;
      }
    };

    onMounted(async () => {
      serverState.showSpinner = true;
      await fetchBackInfo();
      await loadUserInfo();
      serverState.showSpinner = false;
    });

    return {
      isDarktheme,
      serverState,
      user,
      portfolioList,
      cv,
      sml,
      buildInfo,
      fetchData,
    };
  },
};
</script>
